import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from 'components/Loadable';
import WaiterLayout from 'layout/Waiter';
import ErrorBoundary from './ErrorBoundary';

const UserLogin = Loadable(lazy(() => import('pages/user-auth/login')));
const Verify = Loadable(lazy(() => import('pages/user-auth/verify')));
const WaiterTabs = Loadable(lazy(() => import('pages/waiter/waiter-tabs')));
const WaiterForm = Loadable(lazy(() => import('pages/waiter/waiter-form')));
const WaiterRequests = Loadable(lazy(() => import('pages/waiter/waiter-requests')));

// ==============================|| WAITER ROUTING ||============================== //

const WaiterRoutes = {
  path: '/waiter',
  children: [
    {
      path: '/waiter/',
      // element: <AuthLayout />,
      children: [
        { path: 'login', element: <UserLogin />, errorElement: <ErrorBoundary /> },
        { path: 'verify', element: <Verify />, errorElement: <ErrorBoundary /> }
      ]
    },
    {
      path: '/waiter/',
      element: <WaiterLayout onlySpanish />,
      children: [
        {
          index: true,
          element: <Navigate to="profile" replace />
        },
        {
          path: ':tab',
          element: <WaiterTabs />,
          errorElement: <ErrorBoundary />
        },
        {
          path: ':tab/:action',
          element: <WaiterForm />,
          errorElement: <ErrorBoundary />
        },
        {
          path: 'requests',
          element: <WaiterRequests />,
          errorElement: <ErrorBoundary />
        }
      ]
    }
  ]
};

export default WaiterRoutes;
